import { Scope } from "helpers/authenticate";
import { ActionsUnion, createAction } from "store/helper";

import { IFetchCurrentAgentSuccessPayload, IGlobalAccountProperties } from "./interfaces";

export enum SessionActionNames {
  SAVE_CURRENT_AGENT = "FEATURES/SESSION/SAVE_CURRENT_AGENT",
  SAVE_ACCESS_TOKEN = "FEATURES/SESSION/SAVE_ACCESS_TOKEN",
  SAVE_SCOPES = "FEATURES/SESSION/SAVE_SCOPES",
  SAVE_AUTHENTICATION_CREDENTIALS = "FEATURES/SESSION/SAVE_AUTHENTICATION_CREDENTIALS",
  SAVE_CURRENT_LICENSE = "FEATURES/SESSION/SAVE_CURRENT_LICENSE",
  FETCH_CURRENT_AGENT = "FEATURES/SESSION/FETCH_CURRENT_AGENT",
  FETCH_CURRENT_AGENT_SUCCESS = "FEATURES/SESSION/FETCH_CURRENT_AGENT_SUCCESS",
  SET_TRANSIENT_FLAG = "FEATURES/SESSION/SET_TRANSIENT_FLAG",
  LOGOUT = "FEATURES/SESSION/LOGOUT",
}

export const SessionActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCurrentAgent: () => createAction(SessionActionNames.FETCH_CURRENT_AGENT),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCurrentAgentSuccess: (payload: IFetchCurrentAgentSuccessPayload) =>
    createAction(SessionActionNames.FETCH_CURRENT_AGENT_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  saveCurrentAgent: (payload: { id: string; isGhostLogin: boolean; properties?: IGlobalAccountProperties }) =>
    createAction(SessionActionNames.SAVE_CURRENT_AGENT, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  saveAccessToken: (accessToken: string) => createAction(SessionActionNames.SAVE_ACCESS_TOKEN, { accessToken }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  saveScopes: (scopes: Scope[]) => createAction(SessionActionNames.SAVE_SCOPES, { scopes }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setTransientFlag: (name: string, value: boolean) =>
    createAction(SessionActionNames.SET_TRANSIENT_FLAG, { name, value }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  logout: () => createAction(SessionActionNames.LOGOUT),
};

export type SessionAction = ActionsUnion<typeof SessionActions>;
